import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './RoataPricingCTA.css';

const RoataPricingCTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });
  return (
    <motion.section
      className="roata-pricing-cta-section"
      ref={ref}
      initial={{ opacity: 0, x: 80 }}
      animate={isInView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="roata-pricing-cta-container">
        <div className="roata-pricing-cta-left">
          <h2 className="roata-pricing-cta-title">Need a tailored Genix plan?</h2>
          <p className="roata-pricing-cta-desc">
            Talk to our team to create a personalized pricing solution that fits your clinic, hospital, or healthcare workflow perfectly.
          </p>
          <a href="#contact" className="roata-pricing-cta-btn">Get in touch <span style={{marginLeft: 6}}>↗</span></a>
        </div>
        <div className="roata-pricing-cta-right">
          <img src="/images/FootRoatra.png" alt="Genix Roata Dashboard" className="roata-pricing-cta-img main" />
        </div>
      </div>
    </motion.section>
  );
};

export default RoataPricingCTA; 